(function() {
    // List of UTM params you want to preserve
    const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  
    // Function to get query params from current URL
    function getUTMParams() {
      const params = new URLSearchParams(window.location.search);
      let found = {};
      utmParams.forEach(key => {
        if (params.has(key)) {
          found[key] = params.get(key);
        }
      });
      return found;
    }
  
    // Save UTM params in localStorage for persistence
    function saveUTM(params) {
      Object.keys(params).forEach(key => {
        localStorage.setItem(key, params[key]);
      });
    }
  
    // Load stored UTM params
    function loadUTM() {
      let params = {};
      utmParams.forEach(key => {
        let val = localStorage.getItem(key);
        if (val) params[key] = val;
      });
      return params;
    }
  
    // Append UTM params to all internal links
    function updateInternalLinks(params) {
      if (!Object.keys(params).length) return;
      const links = document.querySelectorAll("a[href^='/'], a[href*='" + window.location.host + "']");
      links.forEach(link => {
        let url = new URL(link.href, window.location.origin);
        Object.keys(params).forEach(key => {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, params[key]);
          }
        });
        link.href = url.toString();
      });
    }
  
    // --- Run ---
    const currentParams = getUTMParams();
    if (Object.keys(currentParams).length > 0) {
      saveUTM(currentParams); // save from URL
    }
    const storedParams = loadUTM();
    updateInternalLinks(storedParams);
  })();
  
  